import { useLanguageData } from '@/common/hooks/useLanguageData';
import { ORDER_STATUS_PHASE } from '../constants/orderStatus.constants';
import useOrderStatusSuccessRedirect from '../hooks/useOrderStatusSuccessRedirect';
import {
	BrandMark,
	BrandRow,
	IconBadge,
	Message,
	RedirectNote,
	StatusCard,
	StatusPill,
	Title,
	VisualBlock,
} from '../orderStatusPage.styles';
import { CheckIcon } from './OrderStatusIcons';

const OrderStatusSuccess = ({ params }) => {
	const t = useLanguageData('chat');

	useOrderStatusSuccessRedirect(params, ORDER_STATUS_PHASE.SUCCESS);

	return (
		<StatusCard $phase={ORDER_STATUS_PHASE.SUCCESS} aria-live='polite'>
			<BrandRow>
				<BrandMark>SoftAI</BrandMark>
				<StatusPill $phase={ORDER_STATUS_PHASE.SUCCESS}>
					{t.orderStatusPillSuccess}
				</StatusPill>
			</BrandRow>
			<VisualBlock>
				<IconBadge $phase={ORDER_STATUS_PHASE.SUCCESS} aria-hidden='true'>
					<CheckIcon />
				</IconBadge>
				<Title>
					{params.isTokenPayment
						? t.orderStatusTokensSuccess
						: t.orderStatusPaymentSuccess}
				</Title>
				<Message>
					{params.isTokenPayment
						? t.orderStatusTokensSuccessDescription
						: t.orderStatusPaymentSuccessDescription}
				</Message>
				<RedirectNote>{t.orderStatusRedirecting}</RedirectNote>
			</VisualBlock>
		</StatusCard>
	);
};

export default OrderStatusSuccess;
